var _linearGradient, _path, _path2, _g, _linearGradient2, _path3, _path4, _path5, _linearGradient3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 97,
    x2: 36,
    y2: -1,
    gradientTransform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8d4db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#d8e1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#ebf0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#f9fafb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fillOpacity: 0,
    stroke: "#7191a1",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 21.45,
    y1: 61.55,
    x2: 21.45,
    y2: 21.95
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adccdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c6c7b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 44.1v-4.9c1-.1 1.8-.2 2.3-.5.5-.2.9-.7 1.3-1.2.4-.6.6-1.3.8-2.2.1-.7.2-1.8.2-3.4 0-2.7.1-4.5.4-5.6.2-1 .7-1.9 1.3-2.5s1.6-1.1 2.8-1.5c.8-.2 2.1-.4 3.9-.4h1.1v4.9c-1.5 0-2.5.1-2.9.3-.4.2-.7.4-1 .8-.2.3-.3.9-.3 1.8s-.1 2.5-.2 4.9c-.1 1.4-.2 2.5-.5 3.4-.3.8-.7 1.5-1.1 2.1-.4.5-1.1 1.1-2 1.7.8.5 1.5 1 2 1.6s.9 1.4 1.2 2.3.5 2.1.5 3.6c.1 2.3.1 3.7.1 4.4 0 .9.1 1.5.3 1.9.2.4.6.6 1 .8.4.2 1.4.3 2.9.3v4.9h-1.1c-1.8 0-3.3-.1-4.2-.4-1-.3-1.8-.8-2.5-1.5s-1.1-1.5-1.4-2.5c-.2-1-.3-2.6-.3-4.8 0-2.5-.1-4.2-.3-4.9-.3-1.1-.8-1.9-1.4-2.4-.7-.6-1.6-1-2.9-1z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7,
    y1: 61.45,
    x2: 51.7,
    y2: 21.95
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adccdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c6c7b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.7 44.1c-1 .1-1.8.2-2.3.5-.5.2-.9.7-1.3 1.2-.4.6-.6 1.3-.8 2.2-.1.7-.2 1.8-.2 3.4 0 2.7-.1 4.5-.4 5.6-.2 1.1-.7 1.9-1.3 2.5-.6.6-1.6 1.1-2.8 1.5-.8.2-2.1.4-3.9.4h-1.1v-4.9c1.5 0 2.4-.1 2.9-.3s.8-.5 1-.8c.2-.3.3-.9.3-1.8 0-.8.1-2.4.2-4.8.1-1.4.3-2.6.6-3.4.3-.9.7-1.6 1.2-2.2s1.1-1.1 1.9-1.6c-1-.7-1.8-1.3-2.2-1.9-.6-.9-1.1-2.1-1.3-3.4-.2-1-.3-3.1-.3-6.3 0-1-.1-1.7-.3-2.1-.2-.3-.5-.6-.9-.8-.4-.2-1.4-.3-3-.3V22h1.1c1.8 0 3.3.1 4.2.4 1 .3 1.8.8 2.5 1.5s1.1 1.5 1.4 2.5c.2 1 .4 2.6.4 4.8 0 2.5.1 4.1.3 4.9.3 1.1.8 1.9 1.4 2.3.6.5 1.6.7 2.8.8l-.1 4.9z",
    fill: "url(#c)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 45.037,
    y1: 25.813,
    x2: 58.537,
    y2: 12.313,
    gradientTransform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fafbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#edf1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#dde5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#c7d3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#adbdc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92a5b0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fillOpacity: 0,
    stroke: "#7191a1",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 75.8h3.2v10c0 1.3-.1 2.3-.3 3-.3.9-.9 1.7-1.7 2.2-.8.6-1.9.8-3.2.8-1.6 0-2.8-.4-3.6-1.3-.8-.9-1.3-2.1-1.3-3.8l3-.3c0 .9.2 1.5.4 1.9.3.6.9.8 1.6.8.7 0 1.2-.2 1.5-.6.3-.4.4-1.2.4-2.5V75.8zm5.8 10.6l3.1-.3c.2 1 .6 1.8 1.1 2.3s1.3.7 2.3.7c1 0 1.8-.2 2.3-.7.5-.4.8-.9.8-1.5 0-.4-.1-.7-.3-1-.2-.3-.6-.5-1.1-.7-.4-.1-1.2-.4-2.5-.7-1.7-.4-2.9-.9-3.6-1.6-1-.9-1.5-1.9-1.5-3.2 0-.8.2-1.6.7-2.2.5-.7 1.1-1.2 2-1.6.9-.4 1.9-.5 3.1-.5 2 0 3.5.4 4.5 1.3s1.5 2 1.6 3.5l-3.2.1c-.1-.8-.4-1.4-.9-1.7-.4-.4-1.1-.5-2-.5-.9 0-1.6.2-2.2.6-.3.2-.5.6-.5 1s.2.7.5 1c.4.3 1.4.7 2.9 1.1s2.7.7 3.4 1.1c.7.4 1.3.9 1.7 1.6.4.7.6 1.5.6 2.5 0 .9-.3 1.7-.8 2.5s-1.2 1.4-2.1 1.8c-.9.4-2.1.6-3.4.6-2 0-3.5-.5-4.6-1.4-1.1-1-1.7-2.3-1.9-4.1zm14.8-2.6c0-1.6.2-3 .7-4 .4-.8.8-1.5 1.5-2.2.6-.6 1.3-1.1 2-1.4 1-.4 2.1-.6 3.4-.6 2.3 0 4.2.7 5.6 2.2 1.4 1.4 2.1 3.4 2.1 6 0 2.5-.7 4.5-2.1 6-1.4 1.4-3.2 2.2-5.5 2.2s-4.2-.7-5.6-2.1c-1.4-1.7-2.1-3.6-2.1-6.1zm3.3-.1c0 1.8.4 3.1 1.2 4.1.8.9 1.9 1.4 3.1 1.4s2.3-.5 3.1-1.4c.8-.9 1.2-2.3 1.2-4.1 0-1.8-.4-3.2-1.2-4-.8-.9-1.8-1.3-3.2-1.3s-2.4.4-3.2 1.3c-.6.8-1 2.1-1 4zm14.5 7.8V75.8h3.1l6.4 10.5V75.8h3v15.7H61l-6.3-10.3v10.3h-3z",
    fill: "#4c6c7b"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 36.6,
    y1: 50.98,
    x2: 36.6,
    y2: 33.02
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adccdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c6c7b"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 43.7c-.8-.3-1.2-1-1.2-1.7 0-.8.6-1.5 1.2-1.7.3-.1.4-.3.3-.6-.3-.9-.6-1.7-1-2.4-.1-.3-.4-.3-.7-.2-.3.1-.6.3-.9.3-1 0-1.8-.9-1.8-1.8 0-.3.1-.7.3-.9.1-.3 0-.5-.2-.7-.8-.5-1.6-.8-2.4-1-.3-.1-.5.1-.6.3-.3.8-1 1.2-1.7 1.2-.8 0-1.5-.6-1.7-1.2-.1-.3-.3-.4-.6-.3-.9.3-1.7.6-2.4 1-.3.1-.3.4-.2.7.2.3.3.6.3.9 0 1-.9 1.8-1.8 1.8-.3 0-.7-.1-.9-.3-.3-.1-.5 0-.7.2-.5.8-.8 1.6-1 2.4-.1.3.1.5.3.6.8.3 1.2 1 1.2 1.7 0 .8-.6 1.5-1.2 1.7-.3.1-.4.3-.3.6.3.9.6 1.7 1 2.4.1.3.4.3.7.2.3-.2.6-.3.9-.3 1 0 1.8.9 1.8 1.8 0 .3-.1.7-.3.9-.1.3 0 .5.2.7.8.5 1.6.8 2.4 1h.1c.2 0 .4-.1.5-.3.3-.8 1-1.2 1.7-1.2.8 0 1.5.6 1.7 1.2.1.3.3.4.6.3.9-.3 1.7-.6 2.4-1 .3-.1.3-.4.2-.7s-.3-.6-.3-.9c0-1 .9-1.8 1.8-1.8.3 0 .7.1.9.3.3.1.5 0 .7-.2.5-.8.8-1.6 1-2.4.2-.2 0-.5-.3-.6zm-8.8 1.1c-1.6 0-2.9-1.2-2.9-2.9s1.2-2.9 2.9-2.9 2.9 1.2 2.9 2.9c0 1.6-1.3 2.9-2.9 2.9z",
    fill: "url(#e)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.91221a906f1da60bca24d643ae727449.svg";
export { ForwardRef as ReactComponent };